// extracted by mini-css-extract-plugin
module.exports = {"SurveyTest":"Survey_SurveyTest__FmBaX","Questions":"Survey_Questions__1DQpN","Question":"Survey_Question__35vGI","QuestionTextarea":"Survey_QuestionTextarea__8EtL8"};